export default "__VITE_ASSET__Bzrwl2hQ__"